import { render, staticRenderFns } from "./respuesta.vue?vue&type=template&id=5c0a4aa2&scoped=true"
import script from "./respuesta.vue?vue&type=script&lang=js"
export * from "./respuesta.vue?vue&type=script&lang=js"
import style0 from "./respuesta.vue?vue&type=style&index=0&id=5c0a4aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a4aa2",
  null
  
)

export default component.exports